import type { Driver } from '@cc-shopping/contracts/cross-site/marketplace/types';

const driversConfig: Array<{
  fieldName: Driver;
  label: string;
  showBonusType: boolean;
}> = [
  { fieldName: 'driverAnnualFee', label: 'Annual Fee', showBonusType: false },
  {
    fieldName: 'driverBalanceTransferFeeDescription',
    label: 'Balance Transfer Fee Description',
    showBonusType: false,
  },
  { fieldName: 'driverBonus', label: 'Bonus', showBonusType: false },
  {
    fieldName: 'driverForeignTransactionFee',
    label: 'Foreign Transaction Fee',
    showBonusType: false,
  },
  { fieldName: 'driverIntroApr', label: 'Intro APR', showBonusType: false },
  { fieldName: 'driverIntroOffer', label: 'Intro Offer', showBonusType: true },
  {
    fieldName: 'driverMinimumDeposit',
    label: 'Minimum Deposit',
    showBonusType: false,
  },
  { fieldName: 'driverRegularApr', label: 'Regular APR', showBonusType: false },
  { fieldName: 'driverRewardRate', label: 'Reward Rate', showBonusType: true },
];

export const DRIVER_OPTIONS = driversConfig.map(driver => ({
  label: driver.label,
  value: driver.fieldName,
}));

export const DRIVER_LABELS = driversConfig.reduce(
  (acc, driver) => ({
    ...acc,
    [driver.fieldName]: driver.label,
  }),
  {} as Record<string, string>,
);

export const DRIVERS_WITH_BONUS_TYPES = driversConfig
  .filter(driver => driver.showBonusType)
  .map(driver => driver.fieldName);

const ctaTypeConfig = [
  {
    fieldName: '',
    wpLabel: 'Do not show CTA',
  },
  {
    fieldName: 'applyNow',
    wpLabel: 'Show apply now CTA',
    label: 'How the cards compare',
  },
  {
    fieldName: 'readReview',
    wpLabel: 'Show read review CTA',
    label: 'Still not sure?',
  },
];

export const CTA_LABELS = ctaTypeConfig
  .filter(ctaType => ctaType.label)
  .reduce(
    (acc, ctaType) => ({
      ...acc,
      [ctaType.fieldName]: ctaType.label as string,
    }),
    {} as Record<string, string>,
  );

export const CTA_OPTIONS = ctaTypeConfig.map(ctaType => ({
  label: ctaType.wpLabel,
  value: ctaType.fieldName,
}));
